import React , {useEffect} from "react";
import Coursel from './Coursel'
import Review from "../Review/Review";
import AboutUs from "../AboutUs/AboutUs";
import PricingTable from '../PricingTable/PricingTable'
import Team from '../TeamSection/TeamSection';
import pageHome from '../pageHome/pageHome'
import FirstPage from "../FirsPage.js/FirstPage";
import SideBySideBox from '../SideBySideBox/SideBySideBox';
import ServiceCards from '../ServiceCards/ServiceCards';
import ProjectCards from '../ProjectCards/ProjectCards';
import edubanner from '../../assets/eduban/edu.jpg'
import './Home.css';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';


const Home = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000, // animation duration
            once: true,     // whether animation should happen only once
        });
    }, []);

    return (
        <>

            <SideBySideBox />
            <ServiceCards />
            <pageHome />
            <AboutUs />
            <PricingTable />
            {/* <Team /> */}
            {/* <ProjectCards /> */}
            <div className="edu">
                <div className="containers">
                    <h2 className="pricingTable-title hein">Internship Opportunity.</h2>

                    <div className="image-banner-wrapper" data-aos="fade-up">
                        <img src={edubanner} alt="" className="imeduban" />
                        <a href="/internship" className="edu-btn buttonlo">Apply Now</a>
                    </div>
                </div>
            </div>


            <Review />

        </>
    );
};

export default Home;
